/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.26.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AssetFromJSON, AssetToJSON, CostLaborFromJSON, CostLaborToJSON, CostPartFromJSON, CostPartToJSON, DocumentFromJSON, DocumentToJSON, PerformoTaskFromJSON, PerformoTaskToJSON, PhotographFromJSON, PhotographToJSON, WorkorderLogItemFromJSON, WorkorderLogItemToJSON, } from './';
export function WorkorderCreateCommandFromJSON(json) {
    return WorkorderCreateCommandFromJSONTyped(json, false);
}
export function WorkorderCreateCommandFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'workorderId': !exists(json, 'workorderId') ? undefined : json['workorderId'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'setId': !exists(json, 'setId') ? undefined : json['setId'],
        'pmScheduleId': !exists(json, 'pmScheduleId') ? undefined : json['pmScheduleId'],
        'contactId': !exists(json, 'contactId') ? undefined : json['contactId'],
        'assignToId': !exists(json, 'assignToId') ? undefined : json['assignToId'],
        'surveyId': !exists(json, 'surveyId') ? undefined : json['surveyId'],
        'assignTo': !exists(json, 'assignTo') ? undefined : json['assignTo'],
        'assignToSecondary': !exists(json, 'assignToSecondary') ? undefined : json['assignToSecondary'],
        'propertyId': !exists(json, 'propertyId') ? undefined : json['propertyId'],
        'campus': !exists(json, 'campus') ? undefined : json['campus'],
        'orderBy': !exists(json, 'orderBy') ? undefined : json['orderBy'],
        'orderByField2': !exists(json, 'orderByField2') ? undefined : json['orderByField2'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'emailAssignee': !exists(json, 'emailAssignee') ? undefined : json['emailAssignee'],
        'emailRequester': !exists(json, 'emailRequester') ? undefined : json['emailRequester'],
        'building': !exists(json, 'building') ? undefined : json['building'],
        'floor': !exists(json, 'floor') ? undefined : json['floor'],
        'suite': !exists(json, 'suite') ? undefined : json['suite'],
        'location3': !exists(json, 'location3') ? undefined : json['location3'],
        'jobType': !exists(json, 'jobType') ? undefined : json['jobType'],
        'trade': !exists(json, 'trade') ? undefined : json['trade'],
        'orderStatus': !exists(json, 'orderStatus') ? undefined : json['orderStatus'],
        'closedOutFlag': !exists(json, 'closedOutFlag') ? undefined : json['closedOutFlag'],
        'orderCategory': !exists(json, 'orderCategory') ? undefined : json['orderCategory'],
        'overdueFlag': !exists(json, 'overdueFlag') ? undefined : json['overdueFlag'],
        'completedOrderFlag': !exists(json, 'completedOrderFlag') ? undefined : json['completedOrderFlag'],
        'reqFlag': !exists(json, 'reqFlag') ? undefined : json['reqFlag'],
        'openOrderFlag': !exists(json, 'openOrderFlag') ? undefined : json['openOrderFlag'],
        'orderNumber': !exists(json, 'orderNumber') ? undefined : json['orderNumber'],
        'jobPriority': !exists(json, 'jobPriority') ? undefined : json['jobPriority'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'privateNotes': !exists(json, 'privateNotes') ? undefined : json['privateNotes'],
        'startDateTime': !exists(json, 'startDateTime') ? undefined : (json['startDateTime'] === null ? null : new Date(json['startDateTime'])),
        'startDate': !exists(json, 'startDate') ? undefined : (json['startDate'] === null ? null : new Date(json['startDate'])),
        'startTime': !exists(json, 'startTime') ? undefined : json['startTime'],
        'startTimestampLTZ': !exists(json, 'startTimestampLTZ') ? undefined : (json['startTimestampLTZ'] === null ? null : new Date(json['startTimestampLTZ'])),
        'entryDateTime': !exists(json, 'entryDateTime') ? undefined : (new Date(json['entryDateTime'])),
        'entryDate': !exists(json, 'entryDate') ? undefined : (new Date(json['entryDate'])),
        'entryTime': !exists(json, 'entryTime') ? undefined : json['entryTime'],
        'entryTimestampLTZ': !exists(json, 'entryTimestampLTZ') ? undefined : (json['entryTimestampLTZ'] === null ? null : new Date(json['entryTimestampLTZ'])),
        'entryDateLTZ': !exists(json, 'entryDateLTZ') ? undefined : (json['entryDateLTZ'] === null ? null : new Date(json['entryDateLTZ'])),
        'entryTimeLTZ': !exists(json, 'entryTimeLTZ') ? undefined : json['entryTimeLTZ'],
        'targetDateTime': !exists(json, 'targetDateTime') ? undefined : (json['targetDateTime'] === null ? null : new Date(json['targetDateTime'])),
        'targetDate': !exists(json, 'targetDate') ? undefined : (json['targetDate'] === null ? null : new Date(json['targetDate'])),
        'targetTime': !exists(json, 'targetTime') ? undefined : json['targetTime'],
        'targetTimestampLTZ': !exists(json, 'targetTimestampLTZ') ? undefined : (json['targetTimestampLTZ'] === null ? null : new Date(json['targetTimestampLTZ'])),
        'completionDateTime': !exists(json, 'completionDateTime') ? undefined : (json['completionDateTime'] === null ? null : new Date(json['completionDateTime'])),
        'completionDate': !exists(json, 'completionDate') ? undefined : (json['completionDate'] === null ? null : new Date(json['completionDate'])),
        'completionTime': !exists(json, 'completionTime') ? undefined : json['completionTime'],
        'completionTimestampLTZ': !exists(json, 'completionTimestampLTZ') ? undefined : (json['completionTimestampLTZ'] === null ? null : new Date(json['completionTimestampLTZ'])),
        'didNotCompleteDateTime': !exists(json, 'didNotCompleteDateTime') ? undefined : (json['didNotCompleteDateTime'] === null ? null : new Date(json['didNotCompleteDateTime'])),
        'didNotCompleteFlag': !exists(json, 'didNotCompleteFlag') ? undefined : json['didNotCompleteFlag'],
        'assignedDateTime': !exists(json, 'assignedDateTime') ? undefined : (json['assignedDateTime'] === null ? null : new Date(json['assignedDateTime'])),
        'holdDateTime': !exists(json, 'holdDateTime') ? undefined : (json['holdDateTime'] === null ? null : new Date(json['holdDateTime'])),
        'holdFlag': !exists(json, 'holdFlag') ? undefined : json['holdFlag'],
        'deniedDateTime': !exists(json, 'deniedDateTime') ? undefined : (json['deniedDateTime'] === null ? null : new Date(json['deniedDateTime'])),
        'workorderTimeZone': !exists(json, 'workorderTimeZone') ? undefined : json['workorderTimeZone'],
        'workorderTimeZoneCode': !exists(json, 'workorderTimeZoneCode') ? undefined : json['workorderTimeZoneCode'],
        'workorderTimeZoneDifferenceHours': !exists(json, 'workorderTimeZoneDifferenceHours') ? undefined : json['workorderTimeZoneDifferenceHours'],
        'workorderTimeZoneDifferencial': !exists(json, 'workorderTimeZoneDifferencial') ? undefined : json['workorderTimeZoneDifferencial'],
        'log': !exists(json, 'log') ? undefined : (json['log'] === null ? null : json['log'].map(WorkorderLogItemFromJSON)),
        'assets': !exists(json, 'assets') ? undefined : (json['assets'] === null ? null : json['assets'].map(AssetFromJSON)),
        'costParts': !exists(json, 'costParts') ? undefined : (json['costParts'] === null ? null : json['costParts'].map(CostPartFromJSON)),
        'costLabor': !exists(json, 'costLabor') ? undefined : (json['costLabor'] === null ? null : json['costLabor'].map(CostLaborFromJSON)),
        'procedureName': !exists(json, 'procedureName') ? undefined : json['procedureName'],
        'procedureText': !exists(json, 'procedureText') ? undefined : json['procedureText'],
        'procedureMandatoryFlag': !exists(json, 'procedureMandatoryFlag') ? undefined : json['procedureMandatoryFlag'],
        'unprocessedFailedTasksFlag': !exists(json, 'unprocessedFailedTasksFlag') ? undefined : json['unprocessedFailedTasksFlag'],
        'latitude': !exists(json, 'latitude') ? undefined : json['latitude'],
        'longitude': !exists(json, 'longitude') ? undefined : json['longitude'],
        'gps': !exists(json, 'gps') ? undefined : json['gps'],
        'tasks': !exists(json, 'tasks') ? undefined : (json['tasks'] === null ? null : json['tasks'].map(PerformoTaskFromJSON)),
        'photos': !exists(json, 'photos') ? undefined : (json['photos'] === null ? null : json['photos'].map(PhotographFromJSON)),
        'documents': !exists(json, 'documents') ? undefined : (json['documents'] === null ? null : json['documents'].map(DocumentFromJSON)),
        'multiAssetDisplay': !exists(json, 'multiAssetDisplay') ? undefined : json['multiAssetDisplay'],
        'signatureUrl': !exists(json, 'signatureUrl') ? undefined : json['signatureUrl'],
        'signature': !exists(json, 'signature') ? undefined : json['signature'],
        'billableTo': !exists(json, 'billableTo') ? undefined : json['billableTo'],
        'billableCategory': !exists(json, 'billableCategory') ? undefined : json['billableCategory'],
        'extendedData': !exists(json, 'extendedData') ? undefined : json['extendedData'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
    };
}
export function WorkorderCreateCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'createdBy': value.createdBy,
        'workorderId': value.workorderId,
        'requestId': value.requestId,
        'setId': value.setId,
        'pmScheduleId': value.pmScheduleId,
        'contactId': value.contactId,
        'assignToId': value.assignToId,
        'surveyId': value.surveyId,
        'assignTo': value.assignTo,
        'assignToSecondary': value.assignToSecondary,
        'propertyId': value.propertyId,
        'campus': value.campus,
        'orderBy': value.orderBy,
        'orderByField2': value.orderByField2,
        'phoneNumber': value.phoneNumber,
        'emailAssignee': value.emailAssignee,
        'emailRequester': value.emailRequester,
        'building': value.building,
        'floor': value.floor,
        'suite': value.suite,
        'location3': value.location3,
        'jobType': value.jobType,
        'trade': value.trade,
        'orderStatus': value.orderStatus,
        'closedOutFlag': value.closedOutFlag,
        'orderCategory': value.orderCategory,
        'overdueFlag': value.overdueFlag,
        'completedOrderFlag': value.completedOrderFlag,
        'reqFlag': value.reqFlag,
        'openOrderFlag': value.openOrderFlag,
        'orderNumber': value.orderNumber,
        'jobPriority': value.jobPriority,
        'description': value.description,
        'notes': value.notes,
        'privateNotes': value.privateNotes,
        'startDateTime': value.startDateTime === undefined ? undefined : (value.startDateTime === null ? null : value.startDateTime.toISOString()),
        'startTimestampLTZ': value.startTimestampLTZ === undefined ? undefined : (value.startTimestampLTZ === null ? null : value.startTimestampLTZ.toISOString()),
        'entryDateTime': value.entryDateTime === undefined ? undefined : (value.entryDateTime.toISOString()),
        'entryTimestampLTZ': value.entryTimestampLTZ === undefined ? undefined : (value.entryTimestampLTZ === null ? null : value.entryTimestampLTZ.toISOString()),
        'targetDateTime': value.targetDateTime === undefined ? undefined : (value.targetDateTime === null ? null : value.targetDateTime.toISOString()),
        'targetTimestampLTZ': value.targetTimestampLTZ === undefined ? undefined : (value.targetTimestampLTZ === null ? null : value.targetTimestampLTZ.toISOString()),
        'completionDateTime': value.completionDateTime === undefined ? undefined : (value.completionDateTime === null ? null : value.completionDateTime.toISOString()),
        'completionTimestampLTZ': value.completionTimestampLTZ === undefined ? undefined : (value.completionTimestampLTZ === null ? null : value.completionTimestampLTZ.toISOString()),
        'workorderTimeZone': value.workorderTimeZone,
        'workorderTimeZoneCode': value.workorderTimeZoneCode,
        'workorderTimeZoneDifferenceHours': value.workorderTimeZoneDifferenceHours,
        'log': value.log === undefined ? undefined : (value.log === null ? null : value.log.map(WorkorderLogItemToJSON)),
        'assets': value.assets === undefined ? undefined : (value.assets === null ? null : value.assets.map(AssetToJSON)),
        'costParts': value.costParts === undefined ? undefined : (value.costParts === null ? null : value.costParts.map(CostPartToJSON)),
        'costLabor': value.costLabor === undefined ? undefined : (value.costLabor === null ? null : value.costLabor.map(CostLaborToJSON)),
        'procedureName': value.procedureName,
        'procedureText': value.procedureText,
        'procedureMandatoryFlag': value.procedureMandatoryFlag,
        'unprocessedFailedTasksFlag': value.unprocessedFailedTasksFlag,
        'latitude': value.latitude,
        'longitude': value.longitude,
        'tasks': value.tasks === undefined ? undefined : (value.tasks === null ? null : value.tasks.map(PerformoTaskToJSON)),
        'photos': value.photos === undefined ? undefined : (value.photos === null ? null : value.photos.map(PhotographToJSON)),
        'documents': value.documents === undefined ? undefined : (value.documents === null ? null : value.documents.map(DocumentToJSON)),
        'multiAssetDisplay': value.multiAssetDisplay,
        'signatureUrl': value.signatureUrl,
        'signature': value.signature,
        'billableTo': value.billableTo,
        'billableCategory': value.billableCategory,
        'extendedData': value.extendedData,
        'userId': value.userId,
    };
}
